export const setStripeSetupIntent = 'setStripeSetupIntent';
export const setSelectedProduct = 'setSelectedProduct';
export const setIsAnnual = 'setIsAnnual';
